<template>
	<div>
		<div>
			<kendo-multiselect
                :ref="'multiselect' + _uid"
				v-model="selected"
				:data-source="items"
				:data-text-field="'text'"
				:data-value-field="'id'"
				:data-placeholder="$t('choose')"
				:readonly="readonly"
				:filter="filterPattern"
				@change="inputChanged"
				:name="'dropdown' + _uid"
				:data-vv-as="fieldName || ''"
				:popup="popup"
				:footer-template="nomDropdownSettings.showFooterTemplate ? footerTemplate : ''"
				v-validate="required ? 'required' : ''"
				style="width: 100%;"
			></kendo-multiselect>
		</div>
		<span class="text-danger col-12" v-if="errors.has('dropdown' + _uid)">{{ errors.first('dropdown' + _uid) }}</span>

		<DropdownSettings
            :filterPattern.sync="filterPattern"
            :show.sync="showSettings"
        ></DropdownSettings>
	</div>
</template>

<script>
import Vue from "vue";
import FooterTemplate from "@/components/grid/NomenclatureDropdownFooterTemplate";
import DropdownSettings from "@/components/common/DropdownSettings";
import { mapGetters } from "vuex";

export default {
	inject: ['$validator'],
	components: {
        DropdownSettings,
    },
	props: {
		items: {
			type: Array,
			required: true
		},
		value: [Number, String, Array],
		type: String,
		bindPopup: {
			type: Boolean,
			default: false
		},
		popupContainerId: {
			type: String,
			default: ""
		},
		// Името което показва vee-validate
		fieldName: {
			type: String,
			required: false
		},
		required: {
			type: Boolean,
			default: false
		},
		readonly: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			selected: this.value,
			showSettings: false,
            filterPattern: "",
		};
	},
	methods: {
		inputChanged(event) {
			this.$emit('input', event.sender.value() /* this.selected */);
		},
		footerTemplate: function (e) {
            return {
                template: Vue.component(FooterTemplate.name, FooterTemplate),
                templateArgs: {
                    ...e,
                    btns: [
                        {
                            name: "selectAll",
                            text: this.$t("buttons.selectAll.btnText"),
                            tooltip: this.$t("buttons.selectAll.tooltipText"),
                            class: "btn btn-secondary",
                            icon: "far fa-check-square",
                            show: true,
                            clickHandler: this.selectAll,
                        },
                        {
                            name: "selunselectAllectAll",
                            text: this.$t("buttons.unselectAll.btnText"),
                            tooltip: this.$t("buttons.unselectAll.tooltipText"),
                            class: "btn btn-secondary",
                            icon: "far fa-square",
                            show: true,
                            clickHandler: this.unselectAll,
                        },
                        {
                            name: "staticMultiSelectSettings",
                            text: this.$t("buttons.settings.btnText"),
                            tooltip: this.$t("buttons.settings.btnText"),
                            class: "btn btn-secondary",
                            icon: "fas fa-cog",
                            show: this.nomDropdownSettings.showSettings,
                            clickHandler: () => {
                                this.showSettings = true;
                            },
                        },
                    ],
                },
            };
        },
        selectAll() {
            const multiSelect = this.$refs[`multiselect${this._uid}`];
            if (!multiSelect) return;

            const values = multiSelect.kendoWidget().dataSource.view().map(x => {
                if (x.hasOwnProperty('id')) {
                    return x.id;
                }

                if (x.hasOwnProperty('value')) {
                    return x.value;
                }
            });

            if (values) {
                this.selected = values;
                this.$emit('input', this.selected);
            }
        },
        unselectAll() {
            if (Array.isArray(this.selected)) {
                this.selected.splice(0);
            }
        },
	},
	computed: {
        ...mapGetters(['nomDropdownSettings']),
		popup() {
			const $ = window.kendo && window.kendo.jQuery ? window.kendo.jQuery : null;
			if (!this.bindPopup || !this.popupContainerId || !$) {
				return undefined;
			}

			return {
				appendTo: $(this.popupContainerId)
			};
		}
    },
	watch: {
		value: {
			immediate: true,
			handler(newVal, oldVal) {
				// TODO: Not working because it binds to object not only for id
				this.selected = newVal;
			}
		}
	},
	mounted() {
		this.filterPattern = this.nomDropdownSettings.defaultFilterPattern;
		console.log('create multiselect ...');
	}
};
</script>
